import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface FlyerDataProps extends BaseTemplateProps {
  flyerJobName: string
  partnerId: string
  retailerId: string
  flyerGroupKey: string
}

export const FlyerDataIngestionSuccess: TemplateDefinition<FlyerDataProps> = {
  renderParams: (props: FlyerDataProps) => ({
    messageKey: 'notificationsDomain.templates.flyerDataIngestionSuccess',
    values: {
      flyerJobName: props.flyerJobName,
    },
  }),
  getLink: (props: FlyerDataProps): string => {
    const { partnerId, retailerId, flyerGroupKey } = props
    if (!partnerId || !retailerId || !flyerGroupKey) {
      return ''
    }
    return `/partners/${partnerId}/warehouses/${retailerId}/retailer-collections/flyers/review/${flyerGroupKey}`
  },
}
